<template>
  <c-modal title="Multi-factor Authentication" :show="show" @update:show="toggle">
    <c-row class="mb-3">
      <c-col sm="2">
        <label class="label my-1" for="enabled">
          <span><strong>Enabled</strong></span>
        </label>
      </c-col>
      <c-col>
        <c-switch
          id="enabled"
          class="float-left"
          color="success"
          :checked="this.user.security.mfa.active"
          shape="pill"
          @update:checked="toggleMfa"
        />
      </c-col>
    </c-row>
    <template v-if="this.user.security.mfa.active">
      <c-alert color="warning">
        <p class="lead">
          Warning: You will not be able login until you complete setting up multi-factor authentication.
        </p>
      </c-alert>
      <p class="lead">
        Install the
        <strong>Google Authenticator</strong>
        mobile app and scan this QR code.
      </p>
      <ul>
        <li>
          <a
            href="https://play.google.com/store/apps/details?id=com.google.android.apps.authenticator2&hl=en_AU"
            target="_blank"
          >
            Google Play Store
          </a>
        </li>
        <li>
          <a href="https://apps.apple.com/au/app/google-authenticator/id388497605" target="_blank">iOS App Store</a>
        </li>
      </ul>
      <vue-qr
        v-if="qrCodeText"
        style="width: 200px; margin: 0 auto; display: block"
        class="mt-5"
        logo-src="/img/logos/koala-large.png"
        :text="qrCodeText"
        :size="400"
      ></vue-qr>
    </template>
    <template v-slot:footer>
      <c-button-group>
        <c-button v-if="!isRequesting" color="secondary" @click="close">Close</c-button>
      </c-button-group>
    </template>
  </c-modal>
</template>

<script>
import { authenticator } from 'otplib';
import VueQr from 'vue-qr';
import { buildEndpoint } from '@/libs/buildEndPoint';

export default {
  name: 'UserMfa',
  components: {
    VueQr,
  },
  props: {
    user: Object,
    show: Boolean,
  },
  data() {
    return {
      isRequesting: false,
      secret: '',
    };
  },
  computed: {
    qrCodeText() {
      return this.secret ? authenticator.keyuri(this.user.username, 'KoalaBoss', this.secret) : '';
    },
  },
  mounted() {
    this.secret = this.user.security.mfa.secret;
  },
  methods: {
    toggle(event) {
      if (!event) {
        this.$emit('close');
      }
    },
    close() {
      this.$emit('close');
    },
    async toggleMfa() {
      this.secret = '';
      const newStatus = !this.user.security.mfa.active;
      const data = {
        mfa: newStatus,
      };
      this.$http
        .put(buildEndpoint('account/security/mfa/toggle'), data)
        .then(async (response) => {
          this.error = null;
          if (response.data.success) {
            this.user.security.mfa.active = newStatus;
            if (newStatus) {
              this.secret = await this.generateMfaSecret();
            }
            this.$emit('updated', {
              mfaStatus: newStatus,
              secret: this.secret,
            });
          } else {
            this.$store.commit('addErrorMessage', {
              header: 'Error',
              message: 'Error toggling MFA status',
            });
          }
        })
        .catch((error) => {
          this.$store.commit('addErrorMessage', {
            header: 'Error',
            message: 'Error toggling MFA status',
          });
        });
    },
    async generateMfaSecret() {
      try {
        const response = await this.$http.get(buildEndpoint('account/security/mfa/generate-secret'));
        return response.data.data;
      } catch (error) {
        this.$store.commit('addErrorMessage', {
          header: 'Error',
          message: 'Error toggling MFA status',
        });
      }
    },
  },
};
</script>
